// extracted by mini-css-extract-plugin
export var container = "Layout-module--container--AI465";
export var scrollReference = "Layout-module--scroll-reference--0Reg3";